import { FormEvent, useEffect, useState } from 'react';
import { MdClear, MdPublic, MdRefresh } from 'react-icons/md';
import { MonitoringQuery } from '../types';
import * as Styled from './styles';

type GlobalFilterProps = {
  filters: Pick<MonitoringQuery, 'data_inicio' | 'data_fim'>;
  onApply: (dateRange: Pick<MonitoringQuery, 'data_inicio' | 'data_fim'>) => void;
  onClear: () => void;
};

export function GlobalFilter({ filters, onApply, onClear }: GlobalFilterProps) {
  const [draftFilters, setDraftFilters] = useState(filters);
  const [error, setError] = useState('');

  useEffect(() => setDraftFilters(filters), [filters]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (draftFilters.data_inicio > draftFilters.data_fim) {
      setError('A data inicial deve ser anterior ou igual à data final.');
      return;
    }

    setError('');
    onApply({ data_inicio: draftFilters.data_inicio, data_fim: draftFilters.data_fim });
  };

  const handleClear = () => {
    setError('');
    onClear();
  };

  return (
    <Styled.GlobalFilterWrapper>
      <Styled.GlobalFilterHeader>
        <Styled.GlobalFilterTitle>
          <MdPublic aria-hidden="true" />
          Filtro global
        </Styled.GlobalFilterTitle>
        <Styled.GlobalFilterDescription>
          Selecione um período para aplicá-lo a todas as seções desta página.
          Filtros individuais de cada seção sobrepõem este filtro global.
        </Styled.GlobalFilterDescription>
      </Styled.GlobalFilterHeader>

      <Styled.FilterPanel onSubmit={handleSubmit} aria-label="Filtro global de período">
        <Styled.FilterFields>
          <Styled.Field>
            <label htmlFor="global-start-date">Data inicial</label>
            <input
              id="global-start-date"
              type="date"
              required
              value={draftFilters.data_inicio}
              max={draftFilters.data_fim}
              onChange={event => setDraftFilters(current => ({ ...current, data_inicio: event.target.value }))}
            />
          </Styled.Field>
          <Styled.Field>
            <label htmlFor="global-end-date">Data final</label>
            <input
              id="global-end-date"
              type="date"
              required
              value={draftFilters.data_fim}
              min={draftFilters.data_inicio}
              onChange={event => setDraftFilters(current => ({ ...current, data_fim: event.target.value }))}
            />
          </Styled.Field>
          <Styled.SubmitButton type="submit">
            <MdRefresh aria-hidden="true" />
            Aplicar a todas as seções
          </Styled.SubmitButton>
          <Styled.ClearButton type="button" onClick={handleClear}>
            <MdClear aria-hidden="true" />
            Limpar
          </Styled.ClearButton>
        </Styled.FilterFields>
        {error && <Styled.FormError role="alert">{error}</Styled.FormError>}
      </Styled.FilterPanel>
    </Styled.GlobalFilterWrapper>
  );
}
